import dayjs from 'dayjs';
import { Colors } from '@core/config';
import { useThemeStore } from '@core/theme/useThemeStore';
import DateRangePicker, {
  type DateRangeValue,
} from '@/components/DateRangePicker';

type PayrollDateRangePickerProps = {
  value: DateRangeValue;
  /** Receives the start of the first day and the end of the last day. */
  onChange: (range: DateRangeValue) => void;
  /** Only report the range once the calendar closes (for server fetches). */
  commitOnClose?: boolean;
};

/**
 * The shared Jobs / Dashboard date range picker, bordered to sit inside the
 * white payroll cards.
 */
const PayrollDateRangePicker = ({
  value,
  onChange,
  commitOnClose,
}: PayrollDateRangePickerProps) => {
  const theme = useThemeStore();

  return (
    <DateRangePicker
      value={value}
      onChange={(start, end) =>
        onChange({
          start: dayjs(start).startOf('day').toDate(),
          end: dayjs(end).endOf('day').toDate(),
        })
      }
      commitOnClose={commitOnClose}
      placeholder="Date range"
      primaryBrandColor={theme?.theme?.primaryBrandColor || Colors.LINK_BLUE}
      wrapperClassName="flex items-center rounded-lg border border-gray-300 bg-white px-3 py-3 font-semibold"
      panelMargin="mt-2"
    />
  );
};

export default PayrollDateRangePicker;
